import * as React from 'react';
import XUICheckbox, { XUICheckboxGroup } from '@xero/xui/react/checkbox';

export interface IGroupedCheckboxProps {
    items: IGroupedCheckboxItem[];
    onSelect: (itemId: string) => void;
}

export interface IGroupedCheckboxItem {
    id: string;
    name: string;
    selected: boolean;
}

export default class GroupedCheckbox extends React.Component<IGroupedCheckboxProps> {
    constructor(props: IGroupedCheckboxProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    public render() {
        const { items } = this.props;
        const checkboxes = (
            <XUICheckboxGroup>
                {items.map((item) => (
                    <XUICheckbox onChange={this.onChange} key={item.id} value={item.id} isChecked={item.selected}>
                        {item.name}
                    </XUICheckbox>
                ))}
            </XUICheckboxGroup>
        );

        return checkboxes;
    }

    private onChange(event: React.SyntheticEvent) {
        this.props.onSelect((event.target as HTMLInputElement).value);
    }
}
